import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import DOMPurify from 'dompurify';
import '../styles/markdown.css';

interface MarkdownViewProps {
  content: string;
}

/** 渲染正文：富文本编辑器产出的 HTML（消毒后渲染）或 Markdown（GFM 扩展） */
export default function MarkdownView({ content }: MarkdownViewProps) {
  const trimmed = content.trimStart();
  if (trimmed.startsWith('<')) {
    const clean = DOMPurify.sanitize(content, {
      ADD_TAGS: ['audio', 'source'],
      ADD_ATTR: ['controls', 'preload', 'loop', 'target', 'rel', 'colspan', 'rowspan', 'style'],
    });
    return <div className="prose" dangerouslySetInnerHTML={{ __html: clean }} />;
  }

  return (
    <div className="prose">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ children, href }) => {
            const external = href?.startsWith('http');
            return (
              <a
                href={href}
                {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              >
                {children}
              </a>
            );
          },
          img: ({ src, alt }) =>
            src ? (
              <img src={src} alt={alt ?? ''} loading="lazy" />
            ) : null,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
